import ThemeToggle from "./ThemeToggle/ThemeToggle.jsx";

function Navbar() {

    const authlinks = (
        <ul>
            <li key={"external1"}>
                <a href="https://www.palcare.com/" target={"_self"}>
                    <i className={"fe fe-home"}/> Home
                </a>
            </li>
            <li key={"external2"}>
                <a href={"https://shop.palcare.com/"} target={"_self"}>
                    <i className={"fe fe-shopping-cart"}/> Shop
                </a>
            </li>
            <li key={"external3"}>
                <a href={"https://www.palcare.com/contact-us/"} target={"_self"}>
                    <i className={"fe fe-phone-call"}/> Contact </a>
            </li>
        </ul>
    );

    return (
        <nav className={"landing-navbar bg-dark"} style={{transition: "background-color var(--transition-base), border-color var(--transition-base)"}}>
            <h1>Portal</h1>
            <div style={{display: "flex", alignItems: "center", gap: "var(--space-4)"}}>
                {authlinks}
                {/*<ThemeToggle />*/}
            </div>
        </nav>
    );
}

export default Navbar;